import React, { forwardRef, FunctionComponent, useState } from 'react'
import styles from './PriorityPicker.module.sass'
import clsx from 'clsx'
import ShadowContainer from '../../../etc/popover/ShadowContainer/ShadowContainer'
import Tooltip from 'react-tooltip-lite'
import Popover from '../../../etc/Popover'
import { Classes } from '../../../../styles'

interface PriorityProps {
    className?: string,
    priority: number,
    onClick?: () => void
}

export const Priority = forwardRef<HTMLDivElement, PriorityProps>((props, ref) => <div
    ref={ref}
    className={clsx(props.className, styles.priority, styles[`priority-${props.priority}`])}
    onClick={props?.onClick}
>
    {props.priority}
</div>)

interface Props {
    className?: string,
    priority: number,
    disabled?: boolean,
    onChange?: (status: number) => void,
}

const PriorityPicker: FunctionComponent<Props> = props => {
    const [open, setOpen] = useState(false)

    return <Popover
        positions={['bottom']}
        align={'center'}
        isOpen={open}
        onClickOutside={() => setOpen(false)}
        content={<ShadowContainer className={styles.popover}>
            <div className={styles.header}>Приоритет</div>
            <div className={styles.list}>
                {
                    [...Array(10)].map((_, index) => <Priority
                        key={index}
                        className={styles.hoverable}
                        priority={index + 1}
                        onClick={() => {
                            setOpen(false)
                            props.onChange?.(index + 1)
                        }}
                    />)
                }
            </div>
        </ShadowContainer>}
    >
        <div className={props.className}>
            <Tooltip content={props.disabled ? 'Приоритет' : 'Изменить приоритет'}>
                <div className={Classes.touchTarget} onClick={() => !props.disabled && setOpen(!open)}>
                    <Priority
                        className={clsx(styles.picker, styles.hoverable, {[styles.disabled]: props.disabled})}
                        priority={props.priority || 1}
                    />
                </div>
            </Tooltip>
        </div>
    </Popover>
}

Priority.displayName = 'Priority'

export default PriorityPicker